// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_LinkRecebimentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payments/anticipations/link_recebimento
 *
 * Returns link confirmation + new link record id.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsAnticipations_LinkRecebimentoResponseDados {
linked: boolean
link_id?: number
}

export type SubaccountsAnticipations_LinkRecebimentoResponse = ApiResponse<SubaccountsAnticipations_LinkRecebimentoResponseDados>;

registerResponseContract('SubaccountsAnticipations_LinkRecebimentoResponse', {
  linked:  { type: 'boolean', required: true },
  link_id: { type: 'number',  required: false },
})
